<script>

  import Buttons from "../../../system/components/buttons/buttons.svelte";
  import AddDevice from "../Notificaciones/addDevice.svelte";
  import TableDevic from "../../../admin/config/Notificaciones/tableDevice.svelte";

  let view = {
    status: true
  };
  let newDevic;
  let TableD;


  async function newDevice() {    
    TableD.DesactivarView();
    view.status = false;
    view.status = await newDevic.activeview();
    TableD.inicVista();

  }

  


</script>

  <div class="notif-head">
    <p class="notif-desc">Dispositivos que reciben el aviso cuando una mesa llama.</p>
    <Buttons model="add" on:activated={newDevice} />
  </div>

  <TableDevic bind:this={TableD}/>

<AddDevice bind:this={newDevic} />

<style>
  .notif-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
  }

  .notif-desc {
    margin: 0;
    font-size: 0.8rem;
    color: #83805f;
  }

  .notif-head :global(button) {
    flex: none;
    padding: 0.25rem 0.6rem;
    font-size: 0.8rem;
    white-space: nowrap;
  }
</style>
